import { useEffect, useState } from "react";

const useTextSelectorObserver = () => {
  const [selectedText, setSelectedText] = useState<string>("");

  useEffect(() => {
    const handleSelectionChange = () => {
      const selection = window.getSelection();
      if (selection) {
        const text = selection.toString();
        if (text) setSelectedText(text);
      }
    };

    document.addEventListener("selectionchange", handleSelectionChange);

    return () => {
      document.removeEventListener("selectionchange", handleSelectionChange);
    };
  }, []);

  return selectedText;
}

export default useTextSelectorObserver;
